import { Record } from 'immutable';
import create from './create';

const UnlockHomeworkRecord = new Record({
  studentId: undefined,
  latestUnlockedSequence: undefined,
  totalLessonAmount: undefined,
  sessionNumber: undefined,
  unitNumber: undefined,
  lessonNumber: undefined,
  manualLessonSequence: undefined,
});

class UnlockHomework extends UnlockHomeworkRecord {}

UnlockHomework.crete = create;

export default UnlockHomework;



// WEBPACK FOOTER //
// ./data/UnlockHomework/model.js